import { supabase } from '@/lib/supabase';
import {
  ProjectKpi,
  ProjectWithOrgAndParent,
  SubprojectInvitation,
  Row,
  ProjectWithOrg,
  Org,
} from '@/shared/types/api';

export type SubprojectViewBudgetWithKpi = Row<'subproject_view_budget'> & {
  project_kpis: ProjectKpi;
};

export type ProjectDetails = ProjectWithOrgAndParent & {
  contractor_subproject_invitations: SubprojectInvitation[];
  project_kpis: ProjectKpi[];
};

export const getProjectDetails = async ({
  projectId,
}: {
  projectId: string;
}): Promise<ProjectDetails> => {
  const { data, error } = await supabase
    .from('projects')
    .select(
      `
      *, 
      org:orgs!inner(*),
      subprojects: projects!parent_id(*, contractor_subproject_invitation(*, partner_alias:partner_aliases!inner(*)), project_contractors!project_contractors_subproject_view_id_fkey(*, partner_alias:partner_aliases!inner(*))),
      parent: parent_id(*, org:orgs(*)),
      project_kpis: project_kpis(*),
      subproject_view_budget: subproject_view_budget(*, project_kpis:project_kpis(*))
    `,
    )
    .eq('id', Number(projectId))
    .eq('subprojects.contractor_subproject_invitation.status', 'undecided')
    .is(
      'subprojects.contractor_subproject_invitation.partner_alias.partner_orga_id',
      null,
    )
    .single();

  if (error) {
    throw error;
  }

  const flattenedInvitations = (
    Array.isArray(data.subprojects) ? data.subprojects : []
  ).flatMap(
    (subproject: any) => subproject.contractor_subproject_invitation || [],
  );

  const parent = data.parent ? (data.parent as any as ProjectWithOrg) : null;
  const org = data.org ? (data.org as any as Org) : null;

  return {
    ...data,
    contractor_subproject_invitations: flattenedInvitations,
    parent,
    org,
    project_kpis: [
      ...data.project_kpis,
      ...data.subproject_view_budget
        .map((budget) => budget.project_kpis)
        .filter((kpi) => kpi !== null),
    ],
  };
};
